<template>
  <v-content>
    <v-container>
      <v-card max-width="85%" class="mx-auto">
        <v-card-title>
          <h3 class="mx-auto">
            Create ASO
          </h3>
        </v-card-title>
        <v-card-text>
          <v-alert transition="scroll-y-transition" prominent type="error" :value="error.status">
            {{error.message}}
          </v-alert>
          <v-alert transition="scroll-y-transition" type="success" :value="success.status"
            prominent
          >
            {{success.message}}
          </v-alert>
          <v-form class="text-center" ref="asoForm" @submit.prevent="create">
            <v-text-field
              color="accent"
              v-model="aso.id"
              label="ASO Id"
              :rules="idRules"
            >
            </v-text-field>
            <v-text-field
              color="accent"
              v-model="aso.name"
              label="ASO Name"
              :rules="nameRules"
            >
            </v-text-field>
            <v-text-field
              color="accent"
              v-model="aso.email"
              label="Email"
              :rules="emailRules"
            >
            </v-text-field>
            <v-text-field
              color="accent"
              v-model="aso.otcCode"
              label="One Time Customer Code"
              :rules="otcCodeRules"
            >
            </v-text-field>
            <v-text-field
              color="accent"
              v-model="aso.phone"
              label="ASO Phone Number"
              :rules="phoneRules"
            >
            </v-text-field>
            <v-btn type="submit" :loading="processing" color="accent"> Create ASO</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      processing: false,
      success: {
        status: false,
        message: '',
      },
      error: {
        status: false,
        message: '',
      },
      aso: {
        name: null,
        id: null,
        otcCode: null,
        email: null,
        phone: null,
      },
    };
  },
  methods: {
    async create() {
      this.error.status = false;
      this.success.status = false;
      if (this.$refs.asoForm.validate()) {
        this.processing = true;
        try {
          const aso = await this.firebase.firestore().collection('asos').add(this.aso);
          if (aso.id) {
            this.success.status = true;
            this.success.message = 'ASO Created Successfully';
            this.resetForm();
            this.$refs.asoForm.resetValidation();
          } else {
            this.error.status = true;
            this.error.message = 'Unknown Error! Please try again later.';
          }
          this.processing = false;
        } catch (error) {
          console.log(error);
          this.error.status = true;
          this.error.message = 'Unknown Error! Please try again later.';
          this.processing = false;
        }
        // save ASO here
      }
    },
    resetForm() {
      this.aso.name = null;
      this.aso.id = null;
      this.aso.otcCode = null;
      this.aso.email = null;
    },
  },
  computed: {
    emailRules() {
      return [
        (v) => !!v || 'Email is required',
        (v) => v === null || (v.length === 0) || /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ];
    },
    nameRules() {
      return [
        (v) => !!v || 'Name is required',
        (v) => (v && v.length > 3) || 'Name must be minimum 3 characters',
      ];
    },
    idRules() {
      return [
        (v) => !!v || 'ASO Id is required',
        (v) => (v && v.length > 3) || 'ASO Id must be minimum 3 characters',
      ];
    },
    phoneRules() {
      return [
        // (v) => !!v || 'Phone is required',
        (v) => (v.length === 10) || 'Phone must be 10 characters',
      ];
    },
    otcCodeRules() {
      return [
        (v) => !!v || 'One Time Customer Code is required',
        (v) => (v && v.length > 3) || 'One Time Customer Code must be minimum 3 characters',
      ];
    },
  },
};
</script>
